module.exports = __webpack_public_path__ + "img/ics_f_info_circle_blue.82c3cdea.svg";